import ChevronDown from './src/chevron-down-combined';
export default ChevronDown;